
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/societies",
      function () {
        return require("private-next-pages/societies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/societies"])
      });
    }
  